import { FunctionComponent } from 'react';

import { AvatarDropdown } from './@components/avatar-dropdown';
import { ChatBubble } from './@components/chat-bubble';
import { Greeting } from './@components/greeting';
import { MobileSheet } from './@components/mobile-sheet';
import { SearchBar } from './@components/search-bar';
import { ThemeToggle } from './@components/theme-toggle';

interface TopBarProps {
  greeting?: boolean;
}

export const TopBar: FunctionComponent<TopBarProps> = ({
  greeting = false,
}) => {
  return (
    <>
      <div className='top-0 border-b border-base-500 bg-card sticky top-0 z-50 md:relative'>
        <header className='flex h-16 items-center justify-between gap-4 px-6 px-12'>
          <MobileSheet />
          <SearchBar />
          <div className='flex items-center gap-2'>
            <ChatBubble />
            <AvatarDropdown />
            <ThemeToggle />
          </div>
        </header>
        {greeting && <Greeting />}
      </div>
    </>
  );
};
